import {
  AnimatableObjectList,
  AnimatableObjects,
  AnimationProperties,
  AnimationsKit,
} from '../../types';
import { toArray } from '@wix/wow-utils';

const name = 'BaseObjectProps';
const properties: Partial<AnimationProperties> = {};

function animate(
  kit: AnimationsKit,
  objects: AnimatableObjects,
  duration: number = 0,
  delay: number = 0,
  params: any = {},
) {
  objects = toArray<AnimatableObjects>(objects) as AnimatableObjectList;

  const paramsSet = new Set(
    objects.reduce(
      (acc: string[], object) => acc.concat(Object.keys(object)),
      [],
    ),
  );
  const allowedParams = Array.from(paramsSet) as string[];

  return kit.engine.tween(
    objects,
    { duration, delay, ...params },
    allowedParams,
  );
}

export { name, properties, animate };
